import { PATHS } from '@bb/lib/constants';

export enum PageBlock {
  BlogCarousel = 'BlogCarousel',
  BlogShowcase = 'BlogShowcase',
  Content = 'Content',
  Columns = 'Columns',
  FAQs = 'FAQs',
  FiftyFifty = 'FiftyFifty',
  Tabs = 'Tabs',
  Hero = 'Hero',
  Map = 'Map',
}

export enum LinkType {
  InternalMarketingPage = 'internal',
  InternalNonMarketingPage = 'internal-preset',
  BlogPage = 'blog-page',
  External = 'external',
}

export enum InternalLink {
  Map = 'map',
  Blog = 'blog',
  BlogCategories = 'blog-categories',
  SignUp = 'sign-up',
  Login = 'login',
}

export const InternalLinkPaths: Record<
  InternalLink,
  (typeof PATHS)[keyof typeof PATHS]
> = {
  [InternalLink.Map]: PATHS.Teams,
  [InternalLink.Blog]: PATHS.Blog,
  [InternalLink.BlogCategories]: PATHS.Blog,
  [InternalLink.SignUp]: PATHS.SignUp,
  [InternalLink.Login]: PATHS.Login,
};

export const InternalLinkLabels: Record<InternalLink, string> = {
  [InternalLink.Map]: `Map / Team Find Page - [${InternalLinkPaths[InternalLink.Map]}]`,
  [InternalLink.Blog]: `Blog Page - [${InternalLinkPaths[InternalLink.Blog]}]`,
  [InternalLink.BlogCategories]: `Blog Categories - [${InternalLinkPaths[InternalLink.Blog]}]`,
  [InternalLink.SignUp]: `Sign Up - [${InternalLinkPaths[InternalLink.SignUp]}]`,
  [InternalLink.Login]: `Login - [${InternalLinkPaths[InternalLink.Login]}]`,
};

export enum TailwindMediaQuery {
  Xs = 'xs',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
  Xl = 'xl',
  XXl = '2xl',
}
